import React from 'react';
import { useTranslation } from 'react-i18next';

const Heading = () => {
  const { t } = useTranslation();
  return <h1 className="c-title--main border">{t("Search results list")}</h1>;
}

export default Heading;